import React, { useEffect, useState } from "react";
import usePrefersReducedMotion from "../../hooks/usePrefersReducedMotion";

/** Desktop-only subtle cursor — never blocks clicks. */
export default function CustomCursor() {
  const reduced = usePrefersReducedMotion();
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);
  const [hasMoved, setHasMoved] = useState(false);
  const [label, setLabel] = useState("");
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (reduced || typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    if (!window.matchMedia("(pointer: fine)")?.matches) return undefined;

    const move = (e) => {
      setHasMoved(true);
      setPos({ x: e.clientX, y: e.clientY });
      if (!visible) setVisible(true);
    };

    const hide = () => setVisible(false);
    const show = () => setVisible(true);

    const onOver = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (!t) {
        setLabel("");
        setExpanded(false);
        return;
      }
      setLabel(t.getAttribute("data-cursor") || "");
      setExpanded(Boolean(t.getAttribute("data-cursor")));
    };

    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseleave", hide);
    window.addEventListener("mouseenter", show);
    document.addEventListener("mouseover", onOver);

    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseleave", hide);
      window.removeEventListener("mouseenter", show);
      document.removeEventListener("mouseover", onOver);
    };
  }, [reduced, visible]);

  if (reduced || typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return null;
  }
  if (!window.matchMedia("(pointer: fine)")?.matches) {
    return null;
  }
  if (!hasMoved) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed left-0 top-0 z-[200] hidden md:block"
      aria-hidden
      style={{
        transform: `translate(calc(${pos.x}px - 50%), calc(${pos.y}px - 50%))`,
        opacity: visible ? 1 : 0,
        transition: "opacity 0.2s ease",
      }}
    >
      <div
        className={`flex items-center justify-center rounded-full border transition-all duration-300 ease-out-expo ${
          expanded
            ? "h-16 w-16 border-primary-400/40 bg-primary-600/90 text-[10px] font-bold uppercase tracking-wider text-white backdrop-blur-sm"
            : "h-2.5 w-2.5 border-primary-500/50 bg-primary-500/80"
        }`}
      >
        {label === "view" ? "View" : null}
      </div>
    </div>
  );
}
